var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 3,
    fill: "#009D2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5267 4.68917C15.4548 4.51609 15.3172 4.37854 15.1442 4.30667C15.059 4.27037 14.9676 4.25112 14.875 4.25H11.3333C11.1455 4.25 10.9653 4.32463 10.8325 4.45747C10.6996 4.5903 10.625 4.77047 10.625 4.95833C10.625 5.1462 10.6996 5.32636 10.8325 5.4592C10.9653 5.59204 11.1455 5.66667 11.3333 5.66667H13.1679L9.20833 9.62625L6.87791 7.28875C6.81206 7.22236 6.73372 7.16966 6.6474 7.1337C6.56108 7.09774 6.4685 7.07923 6.37499 7.07923C6.28148 7.07923 6.1889 7.09774 6.10258 7.1337C6.01627 7.16966 5.93792 7.22236 5.87208 7.28875L1.62208 11.5388C1.55568 11.6046 1.50299 11.6829 1.46703 11.7693C1.43107 11.8556 1.41255 11.9482 1.41255 12.0417C1.41255 12.1352 1.43107 12.2278 1.46703 12.3141C1.50299 12.4004 1.55568 12.4787 1.62208 12.5446C1.68792 12.611 1.76627 12.6637 1.85258 12.6996C1.9389 12.7356 2.03148 12.7541 2.12499 12.7541C2.2185 12.7541 2.31108 12.7356 2.3974 12.6996C2.48372 12.6637 2.56206 12.611 2.62791 12.5446L6.37499 8.79042L8.70541 11.1279C8.77126 11.1943 8.8496 11.247 8.93592 11.283C9.02223 11.3189 9.11482 11.3374 9.20833 11.3374C9.30183 11.3374 9.39442 11.3189 9.48073 11.283C9.56705 11.247 9.64539 11.1943 9.71124 11.1279L14.1667 6.66542V8.5C14.1667 8.68786 14.2413 8.86803 14.3741 9.00087C14.507 9.13371 14.6871 9.20833 14.875 9.20833C15.0629 9.20833 15.243 9.13371 15.3759 9.00087C15.5087 8.86803 15.5833 8.68786 15.5833 8.5V4.95833C15.5822 4.86577 15.563 4.77432 15.5267 4.68917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowUp);
export default __webpack_public_path__ + "static/media/grow-up.208a0a97802e089c8f9b23cf8adcc1a7.svg";
export { ForwardRef as ReactComponent };